<template lang="pug">
.table-card
  slot
</template>

<script>
/**
 * Superficie contenedora para tablas y listados.
 *
 * Existía una inconsistencia visible al navegar: en Productos la tabla
 * iba dentro de una card blanca y en Clientes o Ventas quedaba al ras del
 * fondo. Este componente fija una sola superficie para todas.
 */
export default {
  name: 'TableCard',
};
</script>

<style scoped>
.table-card {
  background: var(--escality-surface);
  border: 1px solid var(--escality-gray-200);
  border-radius: var(--escality-radius-lg);
  box-shadow: var(--escality-shadow-sm);
  overflow: hidden;
}

/* La tabla ya trae sus propios bordes: el de la card alcanza. */
.table-card :deep(.p-datatable) {
  border: none;
}

.table-card :deep(.p-datatable .p-datatable-header),
.table-card :deep(.p-datatable .p-paginator) {
  background: transparent;
  border-left: none;
  border-right: none;
}
</style>
